<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <rundna-user-profile [userId]="auth.user.id" [isCoachView]="false" [isSelf]="true"></rundna-user-profile>
</div>
